export default {"src":"/_next/static/media/Venezia.99a8a4ab.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};